// Dependencies
import React, { useState, useEffect, useRef, useCallback, useContext } from "react";
import { ReactSVG } from "react-svg";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { CSSTransitionProps } from "react-transition-group/CSSTransition";
import { Portal } from 'react-portal';

// Types
import { Types, Components } from '../types';

// Utils
import { WP_PLUGIN_BASE_PATH } from '../utils/config'
import {  } from '../utils/helpers'

// Hooks
import { useDebug } from "../hooks";
 
// Components
import { MinicartContext } from "../contexts/Minicart";
import SidebarHeader from "./SidebarHeader";
import SidebarEmpty from "./SidebarEmpty";
import SidebarFooter from "./SidebarFooter";
import SidebarItems from "./SidebarItems";
import Overlay from "./Overlay";

const CartSidebar = ({ className }: any) => {
    
    useDebug('CartSidebar'); 

    // Contexts
    const { loading, updating, opened, items, itemsCount, itemsSubtotal, toggleState, config, translations, theme } = useContext( MinicartContext );

    const transitionProps: CSSTransitionProps = React.useMemo(() => ({
        in: opened,
        //mountOnEnter: true,
        //unmountOnExit: true,
        timeout: Number(theme.general.transition.duration.replace('ms', '')),
      }), [theme.general.transition.duration, opened])
    
    return (<>
        <CSSTransition {...transitionProps}>
            <Portal>
                <div className={`${className}`}>
                    <SidebarHeader className={`${className}-header`} />
                    <SidebarEmpty className={`${className}-empty`} />
                    <SidebarItems className={`${className}-items`} />
                    <SidebarFooter className={`${className}-footer`} />
                </div>           
                <Overlay
                    isPortaled={false}
                    isVisible={opened}
                    disableScrollWhenVisible={true}
                    onClick={() => toggleState('opened', false)}
                    className={[`${className}-overlay`]}
                />
            </Portal>
        </CSSTransition>
    </>) 
}

export default CartSidebar; 